import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

export function BusyIndicator({ label, className }: { label: string; className?: string }) {
  return (
    <span
      className={cn("w-full flex flex-col items-center gap-2.5", className)}
      role="status"
      aria-live="polite"
    >
      <span className="flex items-center gap-2">
        <Spinner className="size-5 text-primary" aria-hidden="true" />
        <span className="text-sm font-semibold">{label}</span>
      </span>
      <span className="block w-full max-w-56 h-1.5 rounded-full bg-primary/25 overflow-hidden">
        <span className="block h-full w-1/3 rounded-full bg-primary animate-indeterminate-bar" />
      </span>
    </span>
  );
}
